export function selectModelsById<T>(collection: Record<string, T>, ids: string[]) : Record<string, T>
{
    return ids.reduce((p, c) => ({ ...p, [c]: collection[c] }), { });
}